// Equal-weight mean of raw_confidence (fallback to confidence) over members.
// Returns { confidence, individuallyRatedCount, totalCount }.
//   confidence = mean of present values (raw_confidence ?? confidence), or null
//   individuallyRatedCount = members with is_estimated === false
//   totalCount = members.length
export function aggregateStudyUnit(memberTopics) {
  if (!memberTopics || memberTopics.length === 0) {
    return { confidence: null, individuallyRatedCount: 0, totalCount: 0 };
  }
  const valued = memberTopics
    .map(t => t.raw_confidence ?? t.confidence)
    .filter(v => v != null);
  const confidence = valued.length === 0
    ? null
    : valued.reduce((a, b) => a + b, 0) / valued.length;
  const individuallyRatedCount = memberTopics.filter(t => !t.is_estimated).length;
  return { confidence, individuallyRatedCount, totalCount: memberTopics.length };
}

// Apply the rate endpoint's response to the in-memory topics array.
// Returns a new array (immutable update) where touched topics have
// confidence/raw_confidence set to confidence_applied and is_estimated=true.
// Untouched topics are returned unchanged (same object reference).
export function applyRateResponse(topics, response) {
  const updatedSet = new Set(response.updated_topic_ids);
  const c = response.confidence_applied;
  return topics.map(t => updatedSet.has(t.id)
    ? { ...t, confidence: c, raw_confidence: c, is_estimated: true }
    : t
  );
}
